<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import {
    getRankTierCircleIconUrl,
    getRankTierTransparentIconUrl,
    getTranslatedRankTierName,
  } from '.';

  export let rankTierName: string;
  export let type: 'circle' | 'transparent';
  $: src =
    type === 'circle'
      ? getRankTierCircleIconUrl(rankTierName)
      : getRankTierTransparentIconUrl(rankTierName);
</script>

<img
  class="rank-tier-image"
  {src}
  alt={getTranslatedRankTierName($LL, rankTierName)}
  {...$$restProps}
/>
